import React, { FC } from 'react';
import { useParams, usePathname } from 'next/navigation';
import { Product } from 'shared/types/product';
import { ProductDetailsProps } from 'components/genius-ui/organisms/product/product-details';
export interface ProductNameMainAttributeProps {
  inModalVersion?: ProductDetailsProps['inModalVersion'];
  dataProps?: {
    productName?: string;
    productMainAttribute?: string;
  };
}

const ProductNameMainAttributeComponent: FC<ProductNameMainAttributeProps> = ({ dataProps }) => {
  const productMainAttribute = dataProps?.productMainAttribute || '';
  const hasMainAttributeData = productMainAttribute && Object.values(productMainAttribute).some((val) => val !== '');
  if (!dataProps?.productName && !hasMainAttributeData) {
    return null;
  }
  return (
    <div className="py-20 pl-12 lg:pl-0">
      <h1 className="font-calibri text-25 font-bold leading-none md:text-40">{dataProps?.productName}</h1>
      {hasMainAttributeData && <div className="mt-1 font-calibri text-24 leading-none">{productMainAttribute}</div>}
    </div>
  );
};

export default ProductNameMainAttributeComponent;
